var map = {
	"./email-a.svg": 43284,
	"./instagram-a.svg": 49664,
	"./messenger-a.svg": 80721,
	"./messenger-b.svg": 23618,
	"./messenger-c.svg": 27347,
	"./web-a.svg": 52958,
	"./whatsapp-a.svg": 60202,
	"./whatsapp-b.svg": 35225,
	"./whatsapp-c.svg": 69832,
	"./whatsapp-d.svg": 59015,
	"./whatsapp-e.svg": 95190,
	"./whatsapp-f.svg": 67061
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77519;